


import {React, useState, useContext, useEffect} from "react"
import { Link, useNavigate } from "react-router-dom"
import{UserContext} from '../../context/userContext/userContext';
import { useStyle } from '../../context/styleContext/styleContext';
import ReactGA from 'react-ga4';
//import ProductCard from "../../components/ProductCard/ProductCard";
//import ProductCardVertical from "../../components/ProductCard/ProductCardVertical";
import {Button, Box, Typography,} from '@mui/material';
import Seo from "../../components/Seo";


export default function SubConfirmPage(){

  const { user } = useContext(UserContext);
  const { isLoading } = useContext(UserContext);
  const { style, setStyle } = useStyle();
  const [isSubConfirmationModalOpen, setSubConfirmationModalOpen] = useState(true);
  const navigate = useNavigate();
    const openSubConfirmationModal = () => setSubConfirmationModalOpen(true);
    const closeSubConfirmationModal = () => setSubConfirmationModalOpen(false);

    const [width, setWidth] = useState(window.innerWidth)
    const [height, setHeight] = useState(window.innerHeight)
    const navToMyGear = () => {
      navigate('/my-gear');
    };


    useEffect(() => {
        function handleResize() {      
          setWidth(window.innerWidth)
      }      
        window.addEventListener('resize', handleResize)
      })



    return(
        <>

<Seo
  title="Subscription Confirmation | Parish Audio"
  description="Your Parish Audio subscription has been confirmed."
  canonical="https://parishaudio.com/subscription-confirmation"
  robots="noindex,nofollow"
/>


        <div style={{marginTop:'0px', minHeight:height-130}}>
          <div style={{padding:'40px', margin:'auto'}}>

         
    <Box
      sx={{
        backgroundColor: style.color9,
        width: '90%',
        maxWidth: 800,
        mx: 'auto',
        my: 0,
        p: 4,
        borderRadius: 2,
        boxShadow: `0 0 100px ${style.color2}`,
        textAlign: 'center',
        color: style.color4,
      }}
    >
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
        Thank You for Subscribing
      </Typography>

      <Typography variant="h6" sx={{ mb: 3 }}>
        Your subscription is now active.
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        You can download and manage your products on the{' '}
        <Link to="/my-gear" style={{ color: style.color4, textDecoration: 'underline' }}>
          My Gear
        </Link>{' '}
        page.
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        Need help installing or activating your software? Visit our{' '}
        <Link to="/support" style={{ color: style.color4, textDecoration: 'underline' }}>
          Support
        </Link>{' '}
        page for guides and troubleshooting tips.
      </Typography>

      <Typography variant="body2" sx={{ mb: 2 }}>
        When you're ready, click below to proceed.
      </Typography>

      <Button
        onClick={navToMyGear}
        sx={{
          fontSize: '1rem',
          backgroundColor: style.color2,
          color: style.color4,
          px: 5,
          py: 1.5,
          borderRadius: 2,
          fontWeight: 600,
          '&:hover': {
            backgroundColor: style.color3,
          },
        }}
      >
        Go to My Gear
      </Button>
    </Box>
    </div>
        </div>
        </>

    )
}